import * as React from 'react';
import RINEXServiceForm from './form';

export default function RINEXServiceCreate() {
  return (
    <RINEXServiceForm />
  );
}